module.exports = __webpack_public_path__ + "img/swf.3d8a0795.svg";